// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"cc31340e","48":"d3ab1a8d","714":"a9dc86ad","950":"b8e65670"}[chunkId] + ".css";
};